// View: Order Complete
function view_order_complete(results) {
  var $ = jQuery;

  ecw_show_loading();

  if (urlParam("orderid")) {
    localStorage.setItem(
      "ecw_customer_order",
      JSON.stringify({ id: urlParam("orderid") })
    );
  }

  if (localStorage.getItem("ecw_customer_order")) {
    var session_order_data = JSON.parse(
      localStorage.getItem("ecw_customer_order")
    );
    var orderguid = session_order_data.id;

    // Remove reveal modal
    $("#order-complete-confirm-checkin, #order-complete-confirm-cancel, #order-complete-favorite-order, #order-complete-delete-favorite-order").each(function () {
      if (typeof $(this).attr("aria-hidden") !== "undefined") {
        $(this).parent().remove();
      }
    });

    $contentContainer
      .load(templateRoot + "wf-ordering-order-complete.html", function () {
        window.scrollTo({
          top: 0,
          behavior: 'smooth' 
        });

        localStorage.removeItem('ecw_customer_grouporderGuid');
        localStorage.removeItem('ecw_customer_group_order_user_type');
        localStorage.removeItem('ecw_customer_group_order_deadline');
        localStorage.removeItem('ecw_customer_group_order_name');
        localStorage.removeItem('ecw_customer_host_group_order_name');

        // Recreate reveal modals
        var $checkin_reveal = new Foundation.Reveal(
          $("#order-complete-confirm-checkin"),
          {}
        );
        var $cancel_reveal = new Foundation.Reveal(
          $("#order-complete-confirm-cancel"),
          {}
        );
        var $favorite_reveal = new Foundation.Reveal(
          $("#order-complete-favorite-order"),
          {}
        );
        var $delete_favorite_reveal = new Foundation.Reveal(
          $("#order-complete-delete-favorite-order"),
          {}
        );

        $('button[data-refresh-order-status]').click(function () {
          displayFinalOrder(orderguid, session_order_data);
        });
        let order_data = results;
        // console.log('results', order_data);

        displayFinalOrder(orderguid, session_order_data, order_data);
      })
      .hide()
      .fadeIn(transitionDuration);
  } else {
    change_view("start-order");
  }
}
function finalOrderDetails(order_data) {
  var $ = jQuery;

  // order_data = JSON.parse(response);
  showOrderStatus(order_data);

  // console.log("session_order_data");
  // console.log(session_order_data);
  // console.log("order_data");
  // console.log(order_data); 
  //display rewards upsell
  if (isUserLoggedIn(true)) {
    $('[data-reward-messaging]').removeClass('hide');
    $('[data-rewards-upsell]').addClass('hide');
  } else {
    $('[data-reward-messaging]').addClass('hide');
    $('[data-rewards-upsell]').removeClass('hide');
  }
  //end of rewards upsell
  if (order_data.deliveryaddress) {
    $('[data-delivery-address]').text(
      order_data.deliveryaddress.streetaddress + ' ' +
      order_data.deliveryaddress.building
    );
    $('[data-delivery-city]').text(
      order_data.deliveryaddress.city + ' ' +
      order_data.deliveryaddress.zipcode
    );
    if (order_data.deliveryaddress.specialinstructions) {
      $('[data-delivery-instructions]').text(order_data.deliveryaddress.specialinstructions);
      $('[data-delivery-instructions]').removeClass('hide');
    }
    $('[data-order-details-delivery]').removeClass('hide');
  }
  if(!localStorage.getItem("ecw_customer_guest_first_name").includes(localStorage.getItem("ecw_customer_guest_email")) ) {
    $("[data-order-customer-name]").text(localStorage.getItem("ecw_customer_guest_first_name") +
    " " +
    localStorage.getItem("ecw_customer_guest_last_name"));
  } else {
    $("[data-order-customer-name]").addClass('hide')
  }
  
  $("[data-order-customer-email]").text(localStorage.getItem("ecw_customer_guest_email"));
  const phone = localStorage.getItem("ecw_customer_guest_phone_number");
  if (typeof phone !== "undefined" && phone !== null && phone !== "undefined") {
    $("[data-order-customer-phone]").text(phone);
    // console.log('adsgasdga')
  }

  $timeText = "";
  if (order_data.delivermode == "dispatch") {
    $timeText = "Order to arrive: ";
    if (order_data.status == "Completed") {
      $timeText = "Order delivered at: ";
    }
  } else {
    $timeText = "Order to be ready: ";
    if (order_data.status == "Completed") {
      $timeText = "Order ready at: ";
    }
  }
  $("[data-order-time-text]").text($timeText);


  $.ajax({
    type: "POST",
    url: ajax_url,
    data: {
      action: "olo_get_restaurant",
      restaurant_id: order_data.vendorid,
      get_calendar: true,
      referer: window.location.href
    },
    success: function (response) {
      var restaurant_data = JSON.parse(response);

      // console.log('restaurant_data', restaurant_data);
      // 
      var locationHours = '';
      $.each(restaurant_data.calendar, function (key, calendar) {
        // console.log('calendar', calendar);
        if (typeof calendar.ranges !== 'undefined' && calendar.ranges !== null && calendar.ranges.length) {
          var storeCalendar = calendar.ranges[0];
          var startDate = new Date(storeCalendar.start.substr(0, 4) + '-' + storeCalendar.start.substr(4, 2) + '-' + storeCalendar.start.substr(6, 2) + 'T' + storeCalendar.start.substr(9, 5));
          var endDate = new Date(storeCalendar.end.substr(0, 4) + '-' + storeCalendar.end.substr(4, 2) + '-' + storeCalendar.end.substr(6, 2) + 'T' + storeCalendar.end.substr(9, 5));

          var hourslabel = calendar.type.charAt(0).toUpperCase() + calendar.type.substr(1).toLowerCase();
          if (calendar.label !== null) {
            hourslabel = calendar.label.charAt(0).toUpperCase() + calendar.label.substr(1).toLowerCase();
          } else if (calendar.type == 'dinein') {
            hourslabel = "Dine In";
          }

          locationHours += '<strong>' + hourslabel + ' Hours: </strong><br>' + formatAMPM(startDate) + ' - ' + formatAMPM(endDate) + '<br>';
          // console.log('locationHours', locationHours);
          $("[data-store-hours]").html(locationHours);
        }
      });

      // //Google address link
      // resturantNameWithReplacedSpaced = restaurant_data.name.replace(' ', '+');
      // let googleAddressLink = 'https://www.google.com/maps/dir/?api=1&destination=ecw%2C+1+' + resturantNameWithReplacedSpaced + '+' + restaurant_data.zip;
      // // console.log(googleAddressLink);
      // $("[data-store-direction-link]").attr("href", googleAddressLink);
      //
      var handoff_mode_label;
      var manual_fire_label;
      var thanks_instructions;
      restaurant_data.labels.forEach(function (label) {



        if (label.key == "manual_fire_label") {
          manual_fire_label = label.value;
        }

        if (label.key == "handoffmode_" + order_data.deliverymode) {
          handoff_mode_label = label.value;
        }

        if (
          label.key ==
          "thanks_" + order_data.deliverymode + "_instructions"
        ) {
          thanks_instructions = label.value;
        } else if (
          label.key ==
          "thanks_" + order_data.deliverymode + "pickup_instructions"
        ) {
          thanks_instructions = label.value;
        } else if (
          label.key ==
          "thanks_" + order_data.deliverymode + "instructions"
        ) {
          thanks_instructions = label.value;
        }
      });

      $("[data-order-checkin-label]").text(manual_fire_label);
      $("[data-order-type]").text(handoff_mode_label);
      $("[data-thanks-instructions]").text(thanks_instructions);

      // console.log(order_data.deliverymode, order_data.status);

      if (
        order_data.deliverymode == "curbside" ||
        order_data.deliverymode == "pickup" ||
        order_data.deliverymode == "drivethru"
      ) {
        $("[data-order-pickup]").removeClass("hide");
        $("[data-order-checkin]").removeClass("hide");
      }

      if (order_data.status == "Completed") {
        $("[data-order-pickup]").addClass("hide");
        $("[data-order-checkin]").addClass("hide");
      }

      var supportsArrivalMessage = false;

      // todo: map this feature for order types other than curbside
      restaurant_data.supportedarrivalmessagehandoffmodes.forEach(
        function (mode) {
          if (
            mode == "CurbsidePickup" &&
            order_data.deliverymode == "curbside"
          ) {
            supportsArrivalMessage = true;
          }
        }
      );

      if (order_data.arrivalstatus != "Order Placed" || !supportsArrivalMessage) {
        $("[data-order-checkin]").addClass("hide");
      }

      $("[data-store-name]").text(restaurant_data.name);
      $("[data-order-details-header]").text(
        order_data.deliverymode + " Details"
      );
      $("[data-store-address]").text(restaurant_data.streetaddress);
      $("[data-store-city]").text(
        restaurant_data.city +
        ", " +
        restaurant_data.state +
        " " +
        restaurant_data.zip
      );
      $("[data-store-phone]").text(restaurant_data.telephone);
      $("[data-store-phone-link]").attr(
        "href",
        "tel:" + restaurant_data.telephone.replace(/\D/g, "")
      );
      $("[data-store-location-link]").attr(
        "href",
        "/locations/" + restaurant_data.slug
      );

      $("[data-store-map]").attr(
        "data-latitude",
        restaurant_data.latitude
      );
      $("[data-store-map]").attr(
        "data-longitude",
        restaurant_data.longitude
      );

      $("[data-order-subtotal]").text(
        "$" + formatMoney(order_data.subtotal)
      );
      $("[data-order-tax]").text(
        "$" + formatMoney(order_data.salestax)
      );

      if (order_data.customerhandoffcharge > 0) {
        $("[data-order-delivery-fee]").text(
          "$" + formatMoney(order_data.customerhandoffcharge)
        );
        $(".delivery-fee-product-item").removeClass("hide");
      }

      if (order_data.tip > 0) {
        $("[data-order-tip]").text("$" + formatMoney(order_data.tip));
        $(".tip-product-item").removeClass("hide");
      }

      if (order_data.discount > 0) {
        $("[data-order-coupon]").text(
          "($" + formatMoney(order_data.discount) + ")"
        );
        $(".coupon-product-item").removeClass("hide");
      }

      $("[data-order-total]").text(
        "$" + formatMoney(order_data.total)
      );

      // Clear product selection readout in event of reload
      $("[data-order-complete-product-selections]  .product-item:not(.hide)").each(function () {
        $(this).remove();
      })
      let restaurant_id = localStorage.getItem("ecw_customer_store_location_id");

      order_data.products.forEach(function (product) {
        // console.log('product', product);
        // console.log('order_data', order_data);
        var $product_item = $("[data-order-complete-product-selections] .product-item.hide").clone();


        $product_item
          .find("[data-qty]")
          .text(product.quantity);
        $product_item
          .find("[data-product-item-name]")
          .text(product.name);
        $product_item
          .find("[data-product-item-custom]")
          .text(product.specialinstructions);
        //for each item in choices array in product add the span with the item to the item-options div
        if (product.choices && product.choices.length) {
          var $dataChoicesContainer = $product_item.find("[data-choices]");
          const choicesCount = product.choices.length;

          // Remove any existing choices to prevent duplicates on re-render
          $dataChoicesContainer.empty();

          // Loop through the product.choices
          for (let ii = 0; ii < choicesCount; ii++) {
            let choice = product.choices[ii];
            let choiceName = choice.name;

            // Create a new <p> element for each choice
            const $newParagraph = $('<p></p>');
            $newParagraph.text(choiceName);

            // Hide elements beyond the first two if there are more than two choices
            if (choicesCount > 2 && ii >= 2) {
              $newParagraph.addClass('hide');
            }

            $dataChoicesContainer.append($newParagraph);
          }

          // Check if a "more choices" button is needed
          if (choicesCount > 2) {
            const $moreButton = $('<button class="more-choices-button"># more choices</button>');
            $moreButton.text(`+ ${choicesCount - 2} more choices`);

            $moreButton.on('click', function () {
              const $thisButton = $(this);
              const $hiddenChoices = $(this).siblings('p.hide');
              const $pChoices = $(this).siblings('p');

              if ($thisButton.hasClass('hide-choices-option')) {
                // Currently in "hide" state, so hide all but the first two
                $pChoices.slice(2).addClass('hide');
                $thisButton.text(`+ ${choicesCount - 2} more choices`).removeClass('hide-choices-option');
              } else {
                // Currently in "show" state, so show all hidden choices
                $hiddenChoices.removeClass('hide');
                $thisButton.text('- hide choices').addClass('hide-choices-option');
              }
            });

            $dataChoicesContainer.append($moreButton);
          }
        }
        else {
          $product_item.find("[data-choices]").addClass("hide");
        }
        $product_item
          .find("[data-product-item-price]")
          .text("$" + formatMoney(product.totalcost));

        $product_item.removeClass("hide");
        $("[data-order-complete-product-selections]").append(
          $product_item
        );
      });

      var show_edit_section = false;
      if (order_data.iseditable) {
        //$('[data-order-complete-edit-order]').removeClass('hide');
        //show_edit_section = true;
      }

      if (
        order_data.status == "Scheduled" ||
        order_data.status == "Pending Manual Fire"
      ) {
        $("[data-order-complete-cancel-order]").removeClass("hide");
        show_edit_section = true;
      }

      if (show_edit_section) {
        $("[data-order-complete-edit-order-section]").removeClass(
          "hide"
        );
      }

      $("[data-order-complete-cancel-order]").off("click");
      $("[data-order-complete-cancel-order]").click(function () {
        $("#order-complete-confirm-cancel").foundation("open");
      });

      $(".confirm-cancel-button").off("click");
      $(".confirm-cancel-button").click(function () {
        $.ajax({
          type: "POST",
          url: ajax_url,
          data: {
            action: "olo_cancel_order",
            orderguid: order_data.id,
            referer: window.location.href,

          },
          success: function (response) {
            var cancel_result = JSON.parse(response);
            // console.log(cancel_result);
            if (cancel_result.status == "Canceled") {
              window.location.reload();
            } else {
              $(".confirm-cancel-error").removeClass("hide");
              $("#order-complete-confirm-cancel").foundation("open");
            }
          },
        });
      });

      $(".checkin-button").off("click");
      $(".checkin-button").click(function () {
        $("#order-complete-confirm-checkin").foundation("open");
      });

      $(".confirm-checkin-button").off("click");
      $(".confirm-checkin-button").click(function () {
        $.ajax({
          type: "POST",
          url: ajax_url,
          data: {
            action: "olo_submit_customer_arrival",
            orderguid: order_data.id,
            referer: window.location.href,

          },
          success: function (response) {
            // console.log(response);
            $("[data-order-checkin]").addClass("hide");
          },
        });
      });

      $(".order-complete-favorite-button").off("click");
      $(".order-complete-favorite-button").click(function () {
        if ($(this).hasClass("location-favorite-active")) {
          $("#order-complete-delete-favorite-order").foundation(
            "open"
          );
        } else {
          $("#order-complete-favorite-order").foundation("open");
        }
      });
      $(".order-complete-favorite-button").addClass("hide");
      $(".confirm-favorite-button").addClass("hide");
      // if (localStorage.getItem("ecw_auth_token")) {
      //   $(".confirm-favorite-button").off("click");
      //   $(".confirm-favorite-button").click(function () {
      //     $.ajax({
      //       type: "POST",
      //       url: ajax_url,
      //       data: {
      //         action: "olo_create_basket_from_order",
      //         authtoken: localStorage.getItem("ecw_auth_token"),
      //         orderid: order_data.id,
      //       },
      //       success: function (response) {
      //         basket_result = JSON.parse(response);

      //         if (basket_result.id) {
      //           $.ajax({
      //             type: "POST",
      //             url: ajax_url,
      //             data: {
      //               action: "olo_set_fave",
      //               authtoken: localStorage.getItem(
      //                 "ecw_auth_token"
      //               ),
      //               basketid: basket_result.id,
      //               description: $(
      //                 "[data-favorite-order-description]"
      //               ).val(),
      //             },
      //             success: function (response) {
      //               fave_result = JSON.parse(response);

      //               if (fave_result.code == 200) {
      //                 alert(fave_result.message);
      //                 $("#order-complete-favorite-order").foundation(
      //                   "open"
      //                 );
      //               } else if (fave_result.faves[0].id) {
      //                 $("[data-fave-id]").text(
      //                   fave_result.faves[0].id
      //                 );

      //                 $(".order-complete-favorite-button").addClass(
      //                   "location-favorite-active"
      //                 );
      //               }
      //             },
      //           });
      //         }
      //       },
      //     });
      //   });
      // } else {

      // }
      $(".order-complete-favorite-button").addClass("hide");
      $(".delete-favorite-button").addClass("hide");
      // if (localStorage.getItem("ecw_auth_token")) {
      //   $(".delete-favorite-button").off("click");
      //   $(".delete-favorite-button").click(function () {
      //     $.ajax({
      //       type: "POST",
      //       url: ajax_url,
      //       data: {
      //         action: "olo_delete_fave",
      //         authtoken: localStorage.getItem("ecw_auth_token"),
      //         faveid: $("[data-fave-id]").text(),
      //       },
      //       success: function (response) {
      //         $("[data-fave-id]").text("");
      //         $(".order-complete-favorite-button").removeClass(
      //           "location-favorite-active"
      //         );
      //       },
      //     });
      //   });
      // } else {

      // }  


      $("[data-order-complete]").removeClass("hide");
      ecw_hide_loading();
    },
  });

}
function displayFinalOrder(orderguid, session_order_data, order_data) {
  var $ = jQuery;
  ecw_show_loading();
  // console.log('order_data', order_data);

  if (order_data) {
    // order_data = JSON.parse(order_data);

    finalOrderDetails(order_data);
  } else {
    // console.log('olo_get_order');

    $.ajax({
      type: "POST",
      url: ajax_url,
      data: {
        action: "olo_get_order",
        orderguid: orderguid,
        referer: window.location.href

      },
      success: function (response) {
        order_data = JSON.parse(response);
        finalOrderDetails(order_data);
      },
    });
  }



}

